import { PaginatedData, PaginationConfig } from '../types/common';
import { PaymentLink, PaymentLinkFormValues } from '../types/PaymentLink';

const mockPaymentLinks: PaymentLink[] = [
  {
    id: 'pl_01J',
    name: 'Curso de inglés básico',
    status: 'active',
    amount: '2999.00',
    created_at: '2026-06-10T14:30:00Z',
    expiration_date: '2026-07-10T14:30:00Z',
    uses: 12,
  },
  {
    id: 'pl_02K',
    name: 'Suscripción mensual premium',
    status: 'active',
    amount: '4999.00',
    created_at: '2026-06-09T10:00:00Z',
    expiration_date: '2026-07-09T10:00:00Z',
    uses: 45,
  },
  {
    id: 'pl_03L',
    name: 'Taller de diseño UX',
    status: 'paused',
    amount: '1500.00',
    created_at: '2026-05-20T09:00:00Z',
    expiration_date: '2026-06-20T09:00:00Z',
    uses: 8,
  },
  {
    id: 'pl_04M',
    name: 'Donación fundación',
    status: 'finished',
    amount: '5000.00',
    created_at: '2026-04-01T08:00:00Z',
    expiration_date: '2026-05-01T08:00:00Z',
    uses: 23,
  },
  {
    id: 'pl_05N',
    name: 'Curso de programación Python',
    status: 'expired',
    amount: '8999.00',
    created_at: '2026-03-15T16:00:00Z',
    expiration_date: '2026-04-15T16:00:00Z',
    uses: 67,
  },
];

export async function fetchPaymentLinks(
  _params: PaginationConfig
): Promise<PaginatedData<PaymentLink>> {
  // const response = await apiFront.get(`payment-links`, { params });
  // return response.data;
  return Promise.resolve({
    current_page: '1',
    per_page: 12,
    page: 1,
    total_elements: mockPaymentLinks.length,
    total_pages: 1,
    data: mockPaymentLinks,
  });
}

export async function createPaymentLink(
  params: PaymentLinkFormValues
): Promise<PaymentLink> {
  // const response = await apiFront.post('payment-links', params);
  // return response.data;
  return Promise.resolve({
    id: 'pl_' + Math.random().toString(36).slice(2, 8).toUpperCase(),
    name: params.name,
    status: 'active',
    amount: params.amount,
    created_at: new Date().toISOString(),
    expiration_date: params.expiration_date,
    uses: 0,
    success_url: params.success_url,
    return_url: params.return_url,
    additional_fields: params.additional_fields,
  });
}

export async function pausePaymentLink(_id: string): Promise<void> {
  // const response = await apiFront.patch(`payment-links/${_id}/pause`);
  // return response.data;
  return Promise.resolve();
}

export async function finishPaymentLink(_id: string): Promise<void> {
  // const response = await apiFront.patch(`payment-links/${_id}/finish`);
  // return response.data;
  return Promise.resolve();
}
